<template>
  <div :class="`p-4 site-list ${viewType}`">
    <c-row class="mb-3">
      <c-col class="view-as">
        View as
        <a href="#" @click="setView('list')">List</a>
        |
        <a href="#" @click="setView('grid')">Grid</a>
      </c-col>
      <c-col>
        <c-button
          v-show="updateCount > 0"
          class="update-all-plugins float-right"
          color="primary"
          size="sm"
          @click="updateAll"
        >
          Update&nbsp;{{ plugin.name }} on {{ updateCount }}&nbsp;site{{ updateCount > 1 ? 's' : '' }}
        </c-button>
      </c-col>
    </c-row>

    <template v-if="viewType === 'list'">
      <c-row
        v-for="(site, index) in sites"
        v-show="(showOnlyRequireUpdates && site.updatesRequired > 0) || !showOnlyRequireUpdates"
        :key="index"
        class="py-2 site-row"
      >
        <c-col class="site-image" sm="2">
          <img v-if="getScreenShot(site)" :src="getScreenShot(site)" class="screenshot" />
          <div v-else class="no-image" />
        </c-col>
        <c-col class="site-name" sm="4">
          <router-link
            :to="{ name: 'detailsSite', params: { siteId: site._id } }"
            v-html="site.name || site.siteAddress"
          ></router-link>
          <p class="mb-0 site-link">{{ site.siteAddress }}</p>
        </c-col>
        <c-col class="site-notes" sm="2">
          <span class="pl-3">{{ site.plugin.Version }}</span>
        </c-col>
        <c-col class="site-notes" sm="2">
          <span
            v-if="site.notes"
            v-c-popover="{
              header: 'Note',
              content: site.notes,
              placement: 'top-start',
              size: 'lg',
            }"
            class="mt-2 d-block"
          >
            <c-icon :content="freeSet.cilList" />
            Note
          </span>
        </c-col>
        <c-col class="site-actions" sm="2">
          <c-button
            v-if="site.plugin.updateFound"
            class="float-right"
            color="kb-green"
            size="sm"
            @click="updateSingle(site)"
          >
            Update to {{ site.plugin.updateInfo.newVersion }}
          </c-button>
        </c-col>
      </c-row>
    </template>

    <template v-else>
      <c-row class="py-2 site-row">
        <c-col sm="12" md="4" v-for="(site, index) in sites" :key="index" v-show="(showOnlyRequireUpdates && site.updatesRequired > 0) || !showOnlyRequireUpdates">
          <c-card>
            <router-link :to="{ name: 'detailsSite', params: { siteId: site._id } }">
              <c-card-img :src="getScreenShot(site)"/>
            </router-link>
            <c-card-body>
              <c-card-title style="font-size: 1rem">
                <router-link
                    :to="{ name: 'detailsSite', params: { siteId: site._id } }"
                    v-html="site.name || site.siteAddress"
                    class="text-truncate"
                    style="display: inline-block; max-width: 100%"
                />
              </c-card-title>
              <c-card-subtitle class="text-truncate" style="display: inline-block; max-width: 100%">{{site.siteAddress}}</c-card-subtitle>
            </c-card-body>
            <c-card-footer>
              <span>{{ site.plugin.Version }}</span>
              <a
                  v-if="site.plugin.updateFound"
                  class="link float-right"
                  href="#"
                  @click="updateSingle(site)"
              >
                Update to {{ site.plugin.updateInfo.newVersion }}
              </a>
            </c-card-footer>
          </c-card>
        </c-col>
<!--        <c-col-->
<!--          v-for="(site, index) in sites"-->
<!--          v-show="(showOnlyRequireUpdates && site.updatesRequired > 0) || !showOnlyRequireUpdates"-->
<!--          :key="index"-->
<!--          class="site-image mb-3"-->
<!--          sm="12"-->
<!--          md="3"-->
<!--        >-->
<!--          <div class="align-bottom site-name-wrapper d-flex align-bottom">-->
<!--            <router-link-->
<!--              class="site-name"-->
<!--              :to="{ name: 'detailsSite', params: { siteId: site._id } }"-->
<!--              v-html="site.name || site.siteAddress"-->
<!--            />-->
<!--          </div>-->
<!--          <router-link :to="{ name: 'detailsSite', params: { siteId: site._id } }">-->
<!--            <img v-if="getScreenShot(site)" :src="getScreenShot(site)" class="screenshot" />-->
<!--            <div v-else class="no-image"><p>No image</p></div>-->
<!--          </router-link>-->
<!--        </c-col>-->
      </c-row>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import { freeSet } from '@coreui/icons';
import _ from 'lodash';
import io from 'socket.io-client';
import { buildEndpoint } from '../../libs/buildEndPoint';
import { parseScrapeData } from '../../libs/plugin/parseScrapeData';
import Pill from './Pill';

const socket = io(buildEndpoint(''));

/**
 * Update site data for display
 * @param site
 * @param updatedData
 */
function updateSiteData(site, updatedData) {
  site.pluginCount = updatedData.pluginCount;
  site.scrapeData = updatedData.scrapeData;
  site.updatedAt = updatedData.updatedAt;
  site.wpVersion = updatedData.wpVersion;
  site.updatesRequired = updatedData.updatesRequired;
  // Update site name if found - it can change between scrapes
  console.log(updatedData);
  if (updatedData.siteInfo.name !== undefined) {
    site.name = updatedData.siteInfo.name;
  }
}

export default {
  name: 'SiteListForPlugin',
  components: {
    Pill,
  },
  props: {
    plugin: Object,
    sites: Array,
    readOnly: Boolean,
    hideHeader: Boolean,
    noBox: Boolean,
    showOnlyRequireUpdates: Boolean,
  },
  data() {
    return {
      error: null,
      filterSites: null,
      freeSet,
      viewType: 'list',
    };
  },
  computed: {
    updateCount() {
      let updateCount = 0;
      this.sites.forEach((site) => {
        if (site.plugin.updateFound) {
          updateCount += 1;
        }
      });
      return updateCount;
    },
  },
  mounted() {
    const _this = this;
    socket.emit('room', Vue.localStorage.get('mp-sid'));
    socket.on('siteRefreshNotification', (data) => {
      const site = _.find(_this.sites, { _id: data.siteId });
      switch (data.action) {
        // case 'site-refresh-started':
        //   break
        // case 'site-refresh-finished':
        //   console.log(`Refresh! ${site.name}`)
        //   site.isLoading = false;
        //   site.pluginCount = data.data.pluginCount;
        //   site.wpVersion = data.data.wpVersion;
        //   site.updatesRequired = data.data.updatesRequired;
        //   site.updatedAt = data.data.updatedAt;
        //   site.success = data.data.success;
        //   break;
        default:
          break;
      }
    });
  },
  methods: {
    updateAll() {
      this.$emit('updateAll');
    },
    updateSingle(plugin) {
      this.$emit('updateSingle', plugin);
    },
    setView(type) {
      this.viewType = type;
    },
    getScreenShot(site) {
      return _.get(site, 'screenshots.desktop.thumb.url', '');
    },
    clearSearch() {
      this.filterSites = null;
    },
    findSites(site) {
      const searchStr = site.name.toLowerCase() + site.siteAddress.toLowerCase();
      return searchStr.indexOf(this.filterSites) !== -1;
    },
  },
};
</script>

<style lang="scss" scoped="">
.view-as {
  font-size: 14px;

  a {
    font-weight: bold;
    font-size: inherit;
  }
}

.c-dark-theme {
  .site-list {
    background-color: #23242d;

    &.list {
      .site-row {
        border-bottom: 1px solid #333;
      }
    }

    &.grid {
      .site-name {
        color: white;
      }
    }
  }
}

.site-list {
  font-size: 12px;

  &.list {
    .site-row {
      border-bottom: 1px solid #eee;
    }

    .site-name {
      font-weight: bold;

      .site-link {
        font-weight: normal;
      }
    }

    .site-notes {
      & > span {
        cursor: pointer;
      }
    }

    .screenshot {
      max-width: 50px;
      width: 100%;
    }

    .no-image {
      width: 50px;
      height: 31px;
      background: rgba(0, 209, 178, 0.3);
    }
  }

  &.grid {
    .screenshot {
      width: 90%;

      &:hover {
        outline: 1px solid #00d1b2;
      }
    }

    .no-image {
      /*width: 188px;*/
      /*height: 118px;*/
      width: 90%;
      height: 70%;
      background: rgba(0, 209, 178, 0.3);

      p {
        display: inline-block;
        width: 100%;
        text-align: center;
        margin-top: 50px;
      }
    }

    .site-name-wrapper {
      margin-bottom: 10px;
      min-height: 35px;
      height: 35px;
      position: relative;
    }

    .site-name {
      font-weight: bold;
      font-size: 12px;
      position: absolute;
      bottom: 0;
    }
  }
}
</style>
